import * as v from 'valibot';
import { getGraphQLClient } from '../../lib/graphql-client';
import { GetNotificationsSchema } from './schema';
import { GET_NOTIFICATIONS_QUERY } from './query';
import {
  MARK_ALL_NOTIFICATIONS_AS_DISMISSED_MUTATION,
  MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION,
  MARK_ALL_NOTIFICATIONS_AS_UNDISMISSED_MUTATION,
  MARK_NOTIFICATION_AS_DISMISSED_MUTATION,
  MARK_NOTIFICATION_AS_PINNED_MUTATION,
  MARK_NOTIFICATION_AS_READ_MUTATION,
  MARK_NOTIFICATION_AS_UNDISMISSED_MUTATION,
  MARK_NOTIFICATION_AS_UNPINNED_MUTATION,
  MARK_NOTIFICATION_AS_UNREAD_MUTATION,
} from './mutation';
import { type GetNotifications, type MarkAllNotificationsAsDismissedResponse } from './types';

export async function fetchNotifications(): Promise<GetNotifications | undefined> {
  try {
    const gqlClient = getGraphQLClient();

    const response = await gqlClient.query<{ data: GetNotifications; errors: unknown }>(
      GET_NOTIFICATIONS_QUERY,
      {
        options: { channel: 'NOTIFICATION_CENTER', pagination: { limit: 30 } },
      },
    );

    const parsedResponse = v.parse(GetNotificationsSchema, response.data);

    return parsedResponse;
  } catch {
    console.error('Satellite failed to fetch notifications');
    return undefined;
  }
}

export async function markNotificationAsRead(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_READ_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as read');
    return false;
  }
}

export async function markNotificationAsUnread(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_UNREAD_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as unread');
    return false;
  }
}

export async function markNotificationAsPinned(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_PINNED_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as read');
    return false;
  }
}

export async function markNotificationAsUnpinned(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_UNPINNED_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as unread');
    return false;
  }
}

export async function markNotificationAsDismissed(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_DISMISSED_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as dismissed');
    return false;
  }
}

export async function markNotificationAsUndismissed(id: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_NOTIFICATION_AS_UNDISMISSED_MUTATION, {
      id,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark notification as undismissed');
    return false;
  }
}

export async function markAllNotificationsAsRead() {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION, {
      track: [],
    });

    return true;
  } catch {
    console.error('Satellite failed to mark all notifications as read');
    return false;
  }
}

export async function markAllNotificationsAsDismissed() {
  try {
    const gqlClient = getGraphQLClient();

    const response = await gqlClient.mutation<MarkAllNotificationsAsDismissedResponse>(
      MARK_ALL_NOTIFICATIONS_AS_DISMISSED_MUTATION,
      {
        track: [],
      },
    );

    return response;
  } catch {
    console.error('Satellite failed to mark all notifications as dismissed');
    return false;
  }
}

export async function markAllNotificationsAsUndismissed(operationId: string) {
  try {
    const gqlClient = getGraphQLClient();

    await gqlClient.mutation(MARK_ALL_NOTIFICATIONS_AS_UNDISMISSED_MUTATION, {
      track: [],
      operationId,
    });

    return true;
  } catch {
    console.error('Satellite failed to mark all notifications as undismissed');
    return false;
  }
}
